type ResearchApplicable = {
  congestionManagementApplicable: string | null | undefined;
  congestionManagementNotApplicable: string | null | undefined;
  congestionManagementNotYetApplicable: string | null | undefined;
  isResearchApplicable?: string | null | undefined;
};

/**
 * Returns the research applicable text based on the isResearchApplicable value.
 * @param congestionManagementApplicable - The text for 'YES'.
 * @param congestionManagementNotApplicable - The text for 'NO'.
 * @param congestionManagementNotYetApplicable - The text for 'NOTYET'.
 * @param isResearchApplicable - The report value form the API can be 'YES', 'NOTYET' or 'NO'.
 * @returns The research applicable text.
 */
export const researchApplicable = ({
  congestionManagementApplicable,
  congestionManagementNotApplicable,
  congestionManagementNotYetApplicable,
  isResearchApplicable,
}: ResearchApplicable) => {
  switch (isResearchApplicable) {
    case 'YES':
      return congestionManagementApplicable ?? undefined;
    case 'PENDING':
      return congestionManagementNotYetApplicable ?? undefined;
    case 'NO':
      return congestionManagementNotApplicable ?? undefined;
    default:
      return undefined;
  }
};
